const wineRed300Color = '#aa91a6';

export default wineRed300Color;
